module.exports = __webpack_public_path__ + "static/media/video-2.e6e77539.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/features/video-2.mp4
// module id = 372
// module chunks = 0